import React, { useState, useCallback, useEffect } from 'react';
import {BrowserRouter as Router, Route, Redirect, Switch} from "react-router-dom";

// Navigations
import MainNavigation from "./shared/components/Navigation/MainNavigation";
import SecondNav from './shared/components/Navigation/SecondNav';

// Authentication and User pages
import { AuthContext } from "./shared/context/auth-context";
import ProtectedRoute from './auth/protectedRoute';
import Login from './auth/Auth';
import Posts from './user/pages/Posts';
import CreatePost from './user/u-components/createPost';
import User from './user/user-profile/User';


// Admin Dashboard
// import Admin from './admin/dashboard/admin-profile/Admin-profile';
import AdminDashboard from './admin/dashboard/admin-page/admin-dashboard';

// Main pages
import Home from "./shared/main-page/home";
import Mend from './admin/components/mend/pages/mend';
import NewsById from './admin/components/news/pages/newsById';
import AddNews from './admin/components/news/pages/AddNews';
import UpdateNews from './admin/components/news/pages/UpdateNews';

import AddMend from './admin/components/mend/pages/AddMend';
import AddCourse from './admin/components/course/pages/addCourse';

//Responsive pages
import Mends from './admin/components/mend/pages/mends';
import Calender from './admin/components/calendar/calender';
import Course from './admin/components/course/pages/course';

// Дацан
import Tsogchen from './admin/components/datsan/tsogchen';
import BadmaYoga from './admin/components/datsan/badma';
import Dashichoimbol from './admin/components/datsan/dashi';
import Gungaa from  './admin/components/datsan/gunga';
import Idgaa from  './admin/components/datsan/idga';
import Janraisig from  './admin/components/datsan/janraisig';
import Mamba from  './admin/components/datsan/mamba';


import './App.css';
import UpdateMend from './admin/components/mend/pages/updateMend';
import UpdateCourse from './admin/components/course/pages/updateCourse';
import Map from './admin/components/map/map';
import Nom from './admin/components/nom/pages/nom'
import PostDetails from './user/u-components/postDetails';
import Gadaad from './admin/components/alba/gadaad';
import Tamga from './admin/components/alba/tamga';
import Olon from './admin/components/alba/olon';
import Hev from './admin/components/alba/hev';
import GandanHistory from './admin/components/taniltsuulga/gandanHistory';
import MHistory from './admin/components/taniltsuulga/MHistory';





const App = () => {
  const [token, setToken] = useState(false);
  const [user, setUser] = useState(false);
  const [role, setRole] = useState(false)
  const [isLoading, setIsLoading] = useState(true);

  const updateUser = (updatedUser) => {
    setUser(updatedUser);
  }

  const login = useCallback((userData, token) => {
    setToken(token);
    setUser(userData);
    setRole(userData.role);
    // Save user data and token to Local Storage

    sessionStorage.setItem(
      'user',
      JSON.stringify({
        user: userData,
        token: token,
        role: userData.role
      })
    )

  }, []);
   

  const logout = useCallback(() => {
    setToken(null)
    setUser(false);
    setRole(false)
    sessionStorage.removeItem('user');
  }, [])

  useEffect(() => {
    const storedUser = JSON.parse(sessionStorage.getItem('user'));
 
    if (storedUser && storedUser.token) {
      const decodedToken = JSON.parse(atob(storedUser.token.split('.')[1])); // Decode token payload
      const expirationTime = decodedToken.exp * 1000; // Convert to milliseconds
      if (Date.now() >= expirationTime) {
        console.log("Token expired, logging out...");
        logout(); // Clear expired token
      } else {
        login(storedUser.user, storedUser.token);
      }

  
    }
    setIsLoading(false)
  },[login, logout])
 
  if(isLoading) return <div>Loading...</div>
  
  const userRoutes = (
    <Switch>
      <ProtectedRoute path='/' exact component={Home} />
      
      <ProtectedRoute path='/user' exact component={User} requiredRole='user'/>
      <ProtectedRoute path='/posts' exact component={Posts}  requiredRole='user'/>
      <ProtectedRoute path='/posts/:postId' exact component={PostDetails} />
      <ProtectedRoute path='/createPost' exact component={CreatePost}  requiredRole='user'/>

      <Route path='/course' exact component={Course} />
      <Route path='/news/:newsId' exact component={NewsById} />
      <Route path='/mend/:mendId' exact  component={Mend} />
      <Route path='/mend' exact component={Mends}         />

      <Route path='/nom' exact component={Nom} />
      <Redirect to='/auth' />
    </Switch>
  );

  const adminRoutes = (
    <Switch>
      <ProtectedRoute path='/admin/dashboard' exact component={AdminDashboard} requiredRole='admin' />
      <ProtectedRoute path='/' exact component={Home} requiredRole='admin' />
      <ProtectedRoute path='/news' exact component={AddNews} requiredRole='admin' />
      <ProtectedRoute path='/update/:newsId' exact component={UpdateNews} requiredRole='admin' />
      <ProtectedRoute path='/updateMend/:mendId' exact component={UpdateMend} requiredRole='admin' />
      <ProtectedRoute path='/updateCourse/:courseId' exact component={UpdateCourse} requiredRole='admin' />
      <ProtectedRoute path='/add-course' exact component={AddCourse} requiredRole='admin' />
      <ProtectedRoute path='/add-mend' exact component={AddMend} requiredRole='admin' />
      <ProtectedRoute path='/calendar' exact component={Calender} requiredRole='admin' />

      <Route path='/course' exact component={Course} />
      <Route path='/news/:newsId' exact component={NewsById} />
      <Route path='/mend/:mendId' exact  component={Mend} />
      
      <Route path='/nom' exact component={Nom} />
      <Redirect to='/admin/dashboard' />
    </Switch>
  );

  const publicRoute = (
    <Switch>
      <Route path='/' exact component={Home} />
      <Route path='/auth' exact component={Login} />
      <Route path='/news/:newsId' exact component={NewsById} />
      <Route path='/mend/:mendId' exact  component={Mend} />
      <Route path='/mend' exact component={Mends} /> 
      <Route path='/course' exact component={Course} />
      <Route path='/calendar' exact component={Calender} />
      <Route path='/posts/:postId' exact component={PostDetails} />

      {/* Дацангууд */}
      <Route path='/map' exact component={Map} />
      <Route path='/tso' exact>    <Tsogchen />      </Route> 
      <Route path='/badma' exact>  <BadmaYoga />     </Route>
      <Route path='/dashi' exact>  <Dashichoimbol /> </Route>
      <Route path='/gunga' exact>  <Gungaa />        </Route>    
      <Route path='/idga' exact>   <Idgaa />         </Route> 
      <Route path='/jan' exact>    <Janraisig />     </Route>  
      <Route path='/mam' exact>    <Mamba />         </Route>

      {/* Алба */}
      <Route path='/gadaad' exact> <Gadaad/>         </Route>
      <Route path='/olon' exact>   <Olon/>           </Route>
      <Route path='/tamga' exact>  <Tamga/>          </Route>
      <Route path='/hev' exact>    <Hev/>            </Route>

      {/* Танилцуулга */}
      <Route path='/history' exact> <GandanHistory/> </Route>
      <Route path='/MHistory' exact> <MHistory/>     </Route>



      <Route path='/nom' exact component={Nom} />
      <Redirect to='/' />
    </Switch>
  )


  return (
    <AuthContext.Provider value={{ isLoggedIn: !!token, token: token, user: user, role: role, login: login, logout: logout, updateUser}} >
      <Router>
        <MainNavigation />
        <SecondNav />
        <Switch>
          {!token && publicRoute}
          {token && role === 'admin' && adminRoutes}
          {token && role === 'user' && userRoutes}
          <Redirect to='/' />
        </Switch>
      </Router>
    </AuthContext.Provider>
  )
}

export default App;
